<template>
  <div class="shime-day edit-item" v-if="editingData && options">

    <div class="head"><b>締め日</b></div>
    <div class="data">
      <div>
        <input-radio :disabled="disabled" :options="options?.shime_day_type" v-model="selectedShimeType" @update="updateType"></input-radio>
      </div>
      <div class="flex flex-align-center" v-if="selectedShimeType === OptionConst.SHIME_DAY_TYPE.SHITEIBI">
        <div class="day">
          <input-text v-model="editingData.shime_day" :type="'number'" inputmode="numeric" class="small" :min="1"
            :max="31" :error="getError(editingData, 'shime_day')" :disabled="disabled"></input-text>
        </div>
        <p class="scale">日</p>
      </div>
      <p>※指定日で31日を指定した場合は自動的に「月末締め」として保存されます</p>
      <p class="current-data" v-if="currentData && currentData.shime_day === OptionConst.SHIME_LAST_DAY">月末締め</p>
      <p class="current-data" v-if="currentData && currentData.shime_day !== OptionConst.SHIME_LAST_DAY">{{
        currentData.shime_day }}日締め</p>
    </div>
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import OptionConst from '@/const/Option';
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null,
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup(props) {
    const { getError } = useForm();

    const selectedShimeType = ref(OptionConst.SHIME_DAY_TYPE.GETSUMATSU)
    const updateType = (shimeType: number) => {
      if (!props.editingData) {
        return
      }
      if (shimeType === OptionConst.SHIME_DAY_TYPE.GETSUMATSU) { //
        props.editingData.shime_day = OptionConst.SHIME_LAST_DAY
      } else {
        props.editingData.shime_day = 1 // 末締めじゃない場合は1日としておく 
      }
    }

    onMounted(() => {
      if (props.editingData) {
        selectedShimeType.value = props.editingData.shime_day === OptionConst.SHIME_LAST_DAY ? OptionConst.SHIME_DAY_TYPE.GETSUMATSU : OptionConst.SHIME_DAY_TYPE.SHITEIBI
      }
    })

    return {
      getError,
      OptionConst,
      updateType,
      selectedShimeType

    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';
</style>
